export default "__VITE_ASSET__BGWu7poI__"